import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
    selector: 'gh-footer',
    templateUrl: 'footer.component.html',
    standalone: false
})

export class FooterComponent {
  gcsCdn = environment.cdnPath;
  cdnTermsPdf = 'https://cdn.gohenry.com/site-furniture/amp-uk/pdfs/';
  footerMenu = [
    {
      label: 'Company',
      menu: [
        { page: 'https://www.gohenry.com/uk/careers/', label: 'Press' },
        { page: 'https://www.gohenry.com/uk/careers/', label: 'Careers' },
        { page: 'https://www.gohenry.com/uk/terms-and-conditions/', label: 'Terms & Conditions' },
        { page: 'https://www.gohenry.com/uk/terms-and-conditions/privacy-policy/', label: 'Privacy Policy' },
        { page: 'https://www.gohenry.com/uk/our-customers/', label: 'Our Customers' },
        { page: 'https://uk.community.gohenry.com/s/article/gb-How-do-I-make-a-complaint', label: 'Complaints' },
        { page: 'https://uk.community.gohenry.com/s/', label: 'Member Support' },
        { page: 'https://www.gohenry.com/uk/terms-and-conditions/accessibility/', label: 'Accessibility' },
        { page: 'https://app.impact.com/campaign-promo-signup/goHenry-UK.brand?execution=e6s1', label: 'Affiliates' }
      ]
    },
    {
      label: 'Resources',
      menu: [
        { page: 'https://www.gohenry.com/uk/blog/online-safety', label: 'Online Safety Tips' },
        { page: 'https://www.gohenry.com/uk/blog/parental-controls', label: 'Parental Controls Tips' },
        { page: 'https://www.gohenry.com/uk/blog/chores', label: 'Chores Tips' },
        { page: 'https://www.gohenry.com/uk/blog/pocket-money', label: 'Pocket Money Tips' },
        { page: 'https://www.gohenry.com/uk/blog/financial-education', label: 'Financial Education Tips' },
        { page: 'https://www.gohenry.com/uk/blog/family', label: 'Family Tips' }
      ]
    },
    {
      label: 'Popular Pages',
      menu: [
        { page: 'https://www.gohenry.com/uk/blog/financial-education/ways-to-teach-kids-about-money', label: 'Teaching Kids About Money' },
        { page: 'https://www.gohenry.com/uk/blog/pocket-money/how-much-pocket-money-should-we-give-our-kids', label: 'How Much Pocket Money' },
        { page: 'https://www.gohenry.com/uk/blog/chores/age-appropriate-chore-list-for-kids', label: 'Age Appropriate Chores' },
        { page: 'https://www.gohenry.com/uk/blog/financial-education/how-to-make-money-as-a-kid', label: 'How to Make Money as a Kid' },
        { page: 'https://www.gohenry.com/uk/blog/financial-education/what-age-can-you-get-a-debit-card-in-the-uk', label: 'What Age Can You Get a Debit Card' },
        { page: 'https://www.gohenry.com/uk/blog/financial-education/how-do-i-open-a-bank-account-for-my-child-online', label: 'How to Open Kids Bank Account' }
      ]
    }
  ];

  constructor() { }
}
